import {  Link,useLocation } from 'react-router-dom';
import { useState } from 'react';
import siteicon from './img/sitelogo.png';

function Navbar()
{
  const location = useLocation();
  const [pathname,setPathname]=useState(location.pathname);
  //console.log(pathname)
    return(
      <nav
        className="navbar navbar-expand-lg bg-white navbar-light sticky-top px-4 px-lg-5"
      >
        <Link to="/home" className="navbar-brand d-flex align-items-center">
          <h1 className="m-0">
            <img
              //className="img-fluid"
              src={siteicon}   //"../img/icon/icon-02-primary.png"
              alt=""
            />
          </h1>
        </Link>
        <button
          type="button"
          className="navbar-toggler"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarCollapse">
          <div className="navbar-nav mx-auto bg-light rounded pe-4 py-3 py-lg-0">
            {
              pathname==='/home'?
              <Link to="/home" className="nav-item nav-link active" >Home</Link>
              :
              <Link to="/home" className="nav-item nav-link">Home</Link>
            }
            {
              pathname==='/about'?
            <Link to="/about" className="nav-item nav-link active">About Us</Link>
            :
            <Link to="/about" className="nav-item nav-link">About Us</Link>
            }
            {
              pathname==='/services'?
            <Link to="/services" className="nav-item nav-link active">Our Services</Link>
            :
            <Link to="/services" className="nav-item nav-link">Our Services</Link>
            }
            {
              pathname==='/partners'?
            <Link to="/partners" className="nav-item nav-link active">Our Partners</Link>
            :
            <Link to="/partners" className="nav-item nav-link">Our Partners</Link>
            }
            
            <a href="http://crm.bseebix.com" className="nav-item nav-link" target='_BLANK' rel="noreferrer">Become a PoSP</a>
            {
              pathname==='/contactus'?
            <Link to="/contactus" className="nav-item nav-link active">Contact Us</Link>
            :
            <Link to="/contactus" className="nav-item nav-link">Contact Us</Link>
            }
            <Link to="https://portal.bseebix.com" className="nav-item nav-link"  target='_blank'>Get A Quote</Link>
          </div>
        </div>
        {/* <a href="https://portal.bseebix.com" rel="noreferrer" className="btn btn-primary px-3 d-none d-lg-block" target='_blank'>Get A Quote</a> */}
      </nav>
      
    )
}
export default Navbar;